// App-level axios instance registry.
// Vue 2 code reached the per-app instance through the static `Vue.$http`;
// Vue 3 has no shared constructor, so store modules living in core/shared
// get the instance from here instead. Each app's axios plugin calls setHttp.
let http = null;

export function setHttp(instance) {
    http = instance;
}

export function getHttp() {
    return http;
}
